import { z } from "zod";

export const SMB_TEMPLATE_MAX_FILES = 12;
export const SMB_TEMPLATE_MAX_BYTES = 10 * 1024 * 1024;
export const smbTemplateUploadResponseSchema = z.object({
  results: z.array(z.object({
    name: z.string(),
    template: z.object({
      id: z.string(), name: z.string(),
      thumbnail: z.string().nullable().optional(),
      brandId: z.string().nullable().optional(),
    }).optional(),
    error: z.string().optional(),
  }).passthrough()),
}).passthrough();
export type SmbTemplateUploadResults = z.infer<typeof smbTemplateUploadResponseSchema>["results"];
export const smbTemplateUploadSchema = z.object({
  scope: z.enum(["global", "brand"]).default("global"),
  brandId: z.string().uuid().optional(),
  categoryId: z.string().uuid().optional(),
  extract: z.enum(["true", "false"]).default("false"),
  confirmed: z.enum(["true", "false"]).default("false"),
  requestId: z.string().uuid(),
}).strict().superRefine((value, context) => {
  if ((value.scope === "brand") !== Boolean(value.brandId))
    context.addIssue({ code: "custom", path: ["brandId"], message: "Brand scope requires a brand ID; global scope must not include one." });
  if (value.extract === "true" && value.confirmed !== "true")
    context.addIssue({ code: "custom", path: ["confirmed"], message: "Confirm paid analysis before uploading." });
});
export const smbTemplateRenderSchema = z.object({
  brandId: z.string().uuid(), personaId: z.string().uuid(),
  narrativeAngleId: z.string().uuid(), productId: z.string().uuid(),
  requestId: z.string().uuid(),
}).strict();
export const smbTemplateVerdictSchema = z.object({
  verdict: z.enum(["pass", "fail"]), notes: z.string().trim().max(2000).default(""),
}).strict();
export const smbTemplateLatestSchema = z.object({
  ids: z.string().max(2400).transform(value => value.split(","))
    .pipe(z.array(z.string().uuid()).min(1).max(60)),
}).strict();
